import posthog from "posthog-js"

let initialized = false

export const PostHog = {
	init: () => {
		if (initialized) return
		const key = import.meta.env.VITE_POSTHOG_KEY
		if (!key) return
		initialized = true
		posthog.init(key, {
			api_host: "https://eu.i.posthog.com",
			autocapture: true,
			capture_pageview: true,
		})
	},
	identify: (id: string, properties?: Record<string, unknown>) => {
		if (!initialized) return
		posthog.identify(id, properties)
	},
	capture: (event: string, properties?: Record<string, unknown>) => {
		if (!initialized) return
		posthog.capture(event, properties)
	},
	setPersonProperties: (props: Record<string, unknown>) => {
		if (!initialized) return
		// Re-identify with updated properties; PostHog merges them
		const id = posthog.get_distinct_id()
		if (id) posthog.identify(id, props)
	},
	reset: () => {
		if (!initialized) return
		posthog.reset()
	},
	shutdown: () => {
		if (!initialized) return
		posthog.opt_out_capturing()
		initialized = false
	},
}
